module.exports = __webpack_public_path__ + "img/0680d34.jpg";